import styled from 'styled-components';
import { fontStyle, baseStyles } from '../commonStyles';

const PARAGRAPH_STYLES = {
  font: 'literata',
  xs: {
    size: 12,
    lh: 16,
  },
  small: {
    size: 14,
    lh: 20,
  },
  base: {
    size: 17,
    lh: 25,
  },
};

export const ParagraphStyleTag = styled.p`
  ${baseStyles}
  ${fontStyle(PARAGRAPH_STYLES)}
`;
